import { DisplayInstallationModalConfig, OnBoardingModal, UI, inferTheme } from "@cede/utils";

export const displayInstallationModal = ({ readOnlyOnboarding, callbackUrl }: DisplayInstallationModalConfig) => {
  const root = document.documentElement;
  if (!root) {
    throw new Error("Could not find root element");
  }

  // Setup UI
  const theme = inferTheme();
  const ui = new UI(root, theme, { selector: ":root", displayLayout: false });

  // Display layout component
  ui.renderHtml(OnBoardingModal({ readOnlyOnboarding, callbackUrl }), { clearPrevious: false, animateOnExit: true });
};
